import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Navbar from "../../../../components/Navbar/Navbar";
import { projectsDLF } from "../../../../data/projects/DLF/data";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import { Helmet } from "react-helmet";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

export const DlfDahlias = () => {
  return (
    <>
      <div>
        <Helmet>
          <title>DLF Dahlias, Sector 54, Gurgaon | Exclusive Residences at Golf Course Road</title>

          <meta
            name="description"
            content="Experience opulent living at DLF Dahlias, Sector 54, Gurgaon – a premium residential project located on Golf Course Road, offering spacious homes, top-notch amenities, and a prime location."
          />

          <meta
            name="keywords"
            content="DLF Dahlias, Sector 54 Gurgaon, DLF Dahlias apartments, Golf Course Road Gurgaon, luxury homes in Gurgaon, DLF premium residences, high-end living Gurgaon, DLF residential projects"
          />

          <link
            rel="canonical"
            href="https://propertystation.in/dlf-dahlias-sector-54-gurugram"
          />

          <meta
            name="robots"
            content="index, follow"
          />

        </Helmet>

        <WhatsAppWidget whatsappdata={projectsDLF.dlfdahlias.whatsapp_dlfdahlias} />
        <Navbar />

        <div className="mt-20">
          <Banner {...projectsDLF.dlfdahlias.bannerdata_dlfdahlias} />
          <Overview {...projectsDLF.dlfdahlias.overview_dlfdahlias} />
          <SiteVisitBanner {...projectsDLF.dlfdahlias.sitevisit_dlfdahlias} />
          <Pricing {...projectsDLF.dlfdahlias.pricing_dlfdahlias} />
          <FloorPlans {...projectsDLF.dlfdahlias.floor_plan_dlfdahlias} />
          <Highlights {...projectsDLF.dlfdahlias.highlights_dlfdahlias} />
          <Amenities />
          <Location {...projectsDLF.dlfdahlias.location_dlfdahlias} />
          <Gallery {...projectsDLF.dlfdahlias.gallery_dlfdahlias} />
          <Faq {...projectsDLF.dlfdahlias.faq_dlfdahlias} />
          <SimilarProject {...projectsDLF.dlfdahlias.similar_dlfdahlias} />
        </div>
      </div>
    </>
  );
};
